const API = {
  CREATE_EXPERT_CONTENT: {
    path: '/expert-content/create',
    method: 'POST',
  },
  DELETE_CONTENT: {
    path: '/expert-content/delete',
    method: 'POST',
  },

};
export default API;
